//React
import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
//API
import { DistributorApi, HospitalApi } from '../apis/index.js';
//Material-UI
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 400,
  backgroundColor: '#FFF',
  border: '2px solid #3F598C',
  boxShadow: '5px 5px 5px 0',
  borderRadius: '10px',
  padding: '10px 25px',
  textAlign: 'center',
};

export default function BasicModal(props) {
  return (
    <div>
      <Modal
        open={props.open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div style={{ ...style }}>
          <div>{props.templateName}</div>
          <div>{props.content}</div>
          <button
            style={{
              backgroundColor: '#3F598C',
              color: '#FFF',
              borderRadius: '20px',
              padding: '5px 50px',
              marginTop: '15px',
              fontFamily: 'Pretandard',
            }}
            onClick={props.handleModalClose}
          >
            Confirm
          </button>
        </div>
      </Modal>
    </div>
  );
}

export function ConfirmModal(props) {
  return (
    <div>
      <Modal
        open={props.open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div style={{ ...style }}>
          <div>{props.content}</div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <button
              style={{
                backgroundColor: '#3F598C',
                color: '#FFF',
                borderRadius: '20px',
                padding: '5px 50px',
                margin: '15px 5px 0px',
                fontFamily: 'Pretandard',
              }}
              onClick={props.handleConfirmModalClose}
            >
              확인
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export function ModalComponent(props) {
  return (
    <div>
      <Modal
        open={props.open}
        close={props.open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div id="modal-modal-description" sx={{ mt: 2 }}>
            {props.content}
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <button
              style={{
                backgroundColor: '#3F598C',
                color: '#FFF',
                borderRadius: '20px',
                padding: '5px 25px',
                marginTop: '15px',
                marginRight: '7px',
                fontFamily: 'Pretandard',
              }}
              onClick={() => props.handleModalClose(true)}
            >
              Confirm
            </button>
            <button
              style={{
                backgroundColor: '#FFF',
                color: '#3F598C',
                border: 'solid 1px #3F598C',
                borderRadius: '20px',
                padding: '5px 25px',
                marginTop: '15px',
                marginLeft: '7px',
                fontFamily: 'Pretandard',
              }}
              onClick={() => props.handleModalClose(false)}
            >
              Cancel
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export function EmailModal(props) {
  const [email, setEmail] = useState('');
  const [modalStatus, setModalStatus] = useState(false);
  const [modalContent, setModalContent] = useState('');

  //Modal
  const handleModalOpen = () => {
    setModalStatus(true);
  };

  const handleModalClose = () => setModalStatus(false);

  const showModalWithContent = (content) => {
    setModalContent(content);
  };

  useEffect(() => {
    if (modalContent) {
      setModalStatus(true);
    }
  }, [modalContent]);

  const confirm = async () => {
    let regex = new RegExp('[a-z0-9]+@[a-z]+.[a-z]{2,3}');
    if (!regex.test(email)) {
      showModalWithContent(`Please enter a valid email address.`);
      handleModalOpen();
      return;
    }
    if (props.email === email) {
      showModalWithContent(`동일한 Email 입니다.`);
      handleModalOpen();
      return;
    }
    let res;
    if (props.role === 'distributor') {
      res = await DistributorApi.emailCheck({
        email: email.toString().trim(),
        hospitalId: props.hospitalId,
      });
    } else {
      res = await HospitalApi.emailCheck({
        email: email.toString().trim(),
        hospitalId: props.hospitalId,
      });
    }
    if (res.statusCode === 200) {
      props.setEmail(email);
      props.handleModalClose();
      return;
    } else {
      showModalWithContent(res.statusCode + '\n' + res.message);
      handleModalOpen();
      return;
    }
  };

  const handlEmail = (e) => {
    setEmail(e.target.value);
  };

  return (
    <div>
      <button onClick={props.handleOpen} style={{ fontFamily: 'Pretandard' }}>
        Open modal
      </button>
      <Modal
        open={props.open}
        // onClose={props.handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...style, borderColor: '#000' }}>
          <Form.Group>
            <div
              id="modal-modal-description"
              sx={{ mt: 2 }}
              style={{
                fontSize: '24px',
                color: '#495057',
                fontWeight: '600',
                marginBottom: '20px',
              }}
            >
              {props.content}
            </div>
            <Form.Control
              type="text"
              placeholder="Enter email address..."
              name="email"
              autoComplete="off"
              onChange={handlEmail}
            ></Form.Control>
          </Form.Group>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
            <button
              style={{
                backgroundColor: '#FFF',
                color: '#000',
                border: 'solid 1px #B6BCC5',
                borderRadius: '10px',
                padding: '5px 25px',
                marginTop: '15px',
                marginLeft: '7px',
                fontFamily: 'Pretandard',
                fontSize: '16px',
                fontWeight: '500',
              }}
              onClick={props.handleModalClose}
            >
              Cancel
            </button>
            <button
              style={{
                backgroundColor: '#000',
                color: '#FFF',
                borderRadius: '10px',
                padding: '5px 25px',
                marginTop: '15px',
                marginRight: '7px',
                fontFamily: 'Pretandard',
                fontSize: '16px',
                fontWeight: '500',
              }}
              onClick={confirm}
            >
              Confirm
            </button>
          </div>
        </Box>
      </Modal>
      <div style={{ display: 'none' }}>
        <BasicModal
          open={modalStatus}
          handleModalClose={handleModalClose}
          content={modalContent}
        />
      </div>
    </div>
  );
}
